import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import { Header } from "@/components/Header";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";

export function Shell() {
  const [collapsed, setCollapsed] = useState(false);
  const [drawer, setDrawer] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    const close = (e) => { if (e.matches) setDrawer(false); };
    mq.addEventListener("change", close);
    return () => mq.removeEventListener("change", close);
  }, []);
  return (
    <div className="flex min-h-screen bg-[var(--bg-canvas)]">
      <div className="hidden md:block shrink-0">
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <Sheet open={drawer} onOpenChange={setDrawer}>
        <SheetContent side="left" data-testid="mobile-nav-drawer" className="p-0 w-72 max-w-[85vw] bg-[var(--surface)] border-[var(--border-subtle)] md:hidden">
          <SheetTitle className="sr-only">Navigation</SheetTitle>
          <Sidebar collapsed={false} mobile onNavigate={() => setDrawer(false)} />
        </SheetContent>
      </Sheet>
      <div className="flex-1 flex flex-col min-w-0">
        <Header onMenu={() => setDrawer(true)} />
        <main className="flex-1 overflow-y-auto overflow-x-hidden grid-noise">
          <div className="p-3 md:p-6 max-w-[1600px] mx-auto animate-rise">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
